<template>
    <div
        class="app-card"
        @mouseleave="closeAction"
        :class="{ 'add-card': isAdd }"
    >
        <div class="img">
            <img v-if="!isAdd" :src="icon || defaultImg" :alt="title" />
        </div>
        <template v-if="$store.state.authorityPoint.DeleteWebapp">
            <div
                class="action-icon"
                @click.stop.prevent="toggleAction"
                v-if="!isAdd"
            >
                <i class="el-icon-more"></i>
                <div class="action-btn" v-if="showAction">
                    <div
                        class="copy"
                        v-if="client.indexOf('PC') === -1"
                        @click.stop.prevent="$emit('copy')"
                    >
                        复制应用
                    </div>
                    <div
                        class="child"
                        @click.stop.prevent="$emit('addChildApp')"
                    >
                        新建子应用
                    </div>
                    <div class="delete" @click.stop.prevent="$emit('delete')">
                        删除应用
                    </div>
                </div>
            </div>
        </template>
        <div v-if="isAdd" class="block-wrap" @click="create('phone')"></div>
        <h3 :title="title">{{ title }}</h3>
        <div
            :class="[
                { 'pc-client': isPcApp() },
                'client',
                `client-length${client.length}`
            ]"
            v-html="getTagContent()"
            v-if="!isAdd"
        ></div>
    </div>
</template>

<script>
const clientMap = {
    App: 'APP',
    MobileSite: 'H5',
    MiniProgram: '小程序',
    PC: 'PC应用'
}

export default {
    name: 'AppCard',

    data() {
        return {
            defaultImg: require('src/common/img/sign_app_def.png'),
            showAction: false
        }
    },

    props: {
        id: String,
        icon: String,
        title: {
            type: String,
            required: true
        },
        // 这个应用是属于什么客户端
        client: {
            type: Array,
            default() {
                return ['PC']
            }
        },
        isAdd: Boolean
    },
    methods: {
        // 是否是PC应用
        isPcApp() {
            return this.client ? this.client.includes('PC') : false
        },
        // 获取应用标识支持哪个客户端，tag里面的内容
        getTagContent() {
            let result = ''
            this.client.forEach(key => {
                result += `<span>${clientMap[key]}</span>`
            })
            return result
        },

        toggleAction() {
            this.showAction = !this.showAction
        },
        closeAction() {
            this.showAction = false
        },
        create(type) {
            this.$emit('create', type)
        }
    }
}
</script>

<style lang="less">
@import '~common/less/var.less';

.app-card {
    display: inline-block;
    position: relative;
    padding-top: 36px;
    width: 172px;
    height: 172px;
    // overflow: hidden;
    border-radius: 4px;
    vertical-align: bottom;
    box-shadow: @shadow-base;
    background: #fff;
    text-align: center;
    cursor: pointer;

    > div.img {
        height: 64px;
        width: 64px;
        margin: 0 auto;
    }
    .img,
    h3 {
        overflow: hidden;
    }
    img {
        width: 100%;
        height: 100%;
        border-radius: 12px;
    }

    .action-icon {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 0;
        right: 8px;
        transition: all 0.3s;
        opacity: 0;
        i {
            font-size: 28px;
            color: #e0e1ea;
        }
    }
    .action-btn {
        position: absolute;
        left: 34px;
        top: 0px;
        width: 110px;
        max-height: 110px;
        text-align: left;
        background-color: #fff;
        z-index: 1;
        padding: 20px;
        font-size: 14px;
        box-shadow: 8px 8px 16px 0 rgba(184, 187, 214, 0.3);
        border-radius: 4px;
        > div {
            line-height: 1.8;
        }
        .copy, .child {
            color: @color-blue;
        }
        .delete {
            color: @color-red;
        }
    }

    h3 {
        font-size: 14px;
        display: -webkit-box;
        margin: 16px 0 6px;
        padding: 0 16px;
        line-height: 20px;
        font-weight: 400;
        color: #6d7283;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        word-break: break-all;
        /*! autoprefixer: off */
        -moz-box-orient: vertical;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    &:hover {
        .action-icon {
            opacity: 1;
        }
    }

    &.add-card {
        background-image: none;
        &::before,
        &::after {
            content: '';
            position: absolute;
            width: 40px;
            height: 6px;
            top: 66px;
            left: 66px;
            background: #d3d8e9;
        }
        &::after {
            transform: rotate(90deg);
        }
        h3 {
            color: @color-gray;
        }
    }
    .block-wrap {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: #fff;
        opacity: 0;
        transition: opacity 0.3s;
    }

    .client {
        width: 125px;
        height: 20px;
        margin: 0 auto;
        font-size: 12px;
        color: #9aacc4;
        background: #f4f8ff;
        border-radius: 91px;
        display: flex;
        justify-content: space-between;
        &.pc-client {
            background: #fff4f4;
        }
        &.client-length1 {
            justify-content: center;
        }
        &.client-length2 {
            padding: 0 25px;
            justify-content: space-around;
        }
        &.client-length3 {
            padding: 0 12.5px;
        }
    }
}
</style>
